/* Team Work contact system — contacts publics lisibles, liens externes sûrs et limites cohérentes Owner/public. */

export const CONTACT_LIMIT = 10;

export const SOCIAL_PLATFORMS = [
  { value: "facebook", label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "tiktok", label: "TikTok" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "youtube", label: "YouTube" },
  { value: "x", label: "X / Twitter" },
  { value: "other", label: "Autre réseau" },
];

export function visibleContactItems(items, legacyValue, fallbackLabel) {
  const normalized = Array.isArray(items)
    ? items.filter((item) => item && item.value && item.visible !== false)
    : [];
  if (normalized.length || !legacyValue) return normalized;
  return [{ label: fallbackLabel, value: String(legacyValue), visible: true }];
}

export function visibleSocialLinks(items) {
  return Array.isArray(items) ? items.filter((item) => item?.url && item.visible !== false) : [];
}

export function socialDisplayName(platform, label) {
  if (label) return label;
  return SOCIAL_PLATFORMS.find((item) => item.value === platform)?.label || "Réseau social";
}

export function toExternalUrl(value) {
  if (!value) return "";
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
}

export function toTelHref(value) {
  return value ? `tel:${String(value).replace(/[^+\d]/g, "")}` : "";
}

export function toWhatsAppHref(value) {
  const digits = String(value || "").replace(/\D/g, "");
  return digits ? `https://wa.me/${digits}` : "";
}
